const apiKey = 'AIzaSyAyu8vRNS1y16Yc0NjRsHBJzjrTBLgN8Go'; // Enter apiKey here // TOOD: Use correct one

const mapOptions: google.maps.MapOptions = {
  zoomControl: true,
  disableDefaultUI: true,
  maxZoom: 18,
  minZoom: 5,
  center: { lat: 48.15806967688501, lng: 16.382443657662837 }
};

export const googleMapsConfig = {
  apiKey,
  mapOptions
};
